import React from 'react';

import { Block, withConfig } from '../common/Block.jsx';
import { EmptyPlaceholder } from '../layout/Builder.jsx';
import { Clickable } from '../common/Button.jsx';
import { Carousel } from '../common/Carousel.jsx';
import { Container, Row } from '../common/Container.jsx';
import { default as _Image } from '../common/Image.jsx';
import { Component as InquirePopup } from './InquirePopup.jsx';
import { default as InventoryHelper, Subtitle } from '../common/Inventory.jsx';
import { SlideshowDot, withSlideshowInitialization } from '../common/Slideshow.jsx';
import PageType from '../common/PageType.jsx';
import { ShareModal, VirtualInstallModal, ZoomModal } from '../common/Popup.jsx';
import { Component as PurchasePopup } from './PurchasePopup.jsx';
import Token from '../common/Token.jsx';
import Utilities from '../common/Utilities.jsx';

// #region LEGACY

class _InventoryMetaComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isArtist: props.config.userType == 1
        };

        this.handleInquireModalClose = this.handleInquireModalClose.bind(this);
        this.handleInquireModalOpen = this.handleInquireModalOpen.bind(this);
        this.handleOfferModalClose = this.handleOfferModalClose.bind(this);
        this.handleOfferModalOpen = this.handleOfferModalOpen.bind(this);
        this.handlePurchaseModalClose = this.handlePurchaseModalClose.bind(this);
        this.handlePurchaseModalOpen = this.handlePurchaseModalOpen.bind(this);
        this.handleShareModalClose = this.handleShareModalClose.bind(this);
        this.handleShareModalOpen = this.handleShareModalOpen.bind(this);
        this.handleVirtualInstallClose = this.handleVirtualInstallClose.bind(this);
        this.handleVirtualInstallOpen = this.handleVirtualInstallOpen.bind(this);
        this.handleZoomModalClose = this.handleZoomModalClose.bind(this);
        this.handleZoomModalOpen = this.handleZoomModalOpen.bind(this);
    }

    componentDidMount() {
        this.setState({
            id: this.props.blockIdentifier
        });
    }

    handleInquireModalClose() {
        this.setState({
            inquireModal: undefined
        });
    }

    handleInquireModalOpen() {
        this.setState({
            inquireModal: {
                visible: true
            }
        });
    }

    handleOfferModalClose() {
        this.setState({
            offerModal: undefined
        });
    }

    handleOfferModalOpen() {
        this.setState({
            offerModal: {
                visible: true
            }
        });
    }

    handlePurchaseModalClose() {
        this.setState({
            purchaseModal: undefined
        });
    }

    handlePurchaseModalOpen() {
        this.setState({
            purchaseModal: {
                visible: true
            }
        });
    }

    handleShareModalClose() {
        this.setState({
            shareModal: undefined
        });
    }

    handleShareModalOpen() {
        this.setState({
            shareModal: {
                visible: true
            }
        });
    }

    handleVirtualInstallClose() {
        this.setState({
            virtualInstallModal: undefined
        });
    }

    handleVirtualInstallOpen() {
        this.setState({
            virtualInstallModal: {
                visible: true
            }
        });
    }

    handleZoomModalClose() {
        this.setState({
            zoomModal: undefined
        });
    }

    handleZoomModalOpen(index) {
        this.setState({
            zoomModal: {
                index: index,
                visible: true
            }
        });
    }

    render() {
        const data = this.props.data || {};
        const inventory = data.inventory || {};
        const edition = InventoryHelper.edition(inventory) || {};
        const seo = inventory.seo || {};
        let imageContent;
        const images = inventory.images || [];
        switch (images.length) {
            case 1:
                if (this.props.imageSize) {
                    let imageStyle;
                    if (!this.props.builder && !this.props.config.canDownloadImages) {
                        imageStyle = { pointerEvents: 'none' };
                    }
                    imageContent = (
                        <img
                            alt={seo.imageAlt}
                            caption={seo.imageCaption}
                            description={seo.imageDescription}
                            src={_Image.url(images[0], undefined, this.props.imageSize)}
                            style={imageStyle}
                            title={seo.imageTitle} />
                    );
                }
            // Intentional fallthrough
            case 0:
                imageContent = (
                    <div className="artwork__img" onClick={this.handleZoomModalOpen}>
                        {imageContent}
                    </div>
                );
                break;
            default:
                if (this.props.imageSize) {
                    imageContent = <Slideshow blockIdentifier={this.state.id} config={this.props.config} data={inventory} imageSize={this.props.imageSize} legacy={true} onClick={this.handleZoomModalOpen} />;
                }
                break;
        }
        const blockConfig = this.props.onNormalizeBlockConfig(this.props);
        let style;
        if (this.props.blockConfig && this.props.blockConfig.layout) {
            style = {};
            Block.mapStyleConfigProps(style, this.props.blockConfig.layout);
        }
        if (this.props.builder) {
            if (!style) {
                style = {};
            }
            style.pointerEvents = 'none';
        }
        const extended = blockConfig.extended || {};
        const showAlternateDimensions = extended.includes && extended.includes.alternateDimensions && extended.includes.alternateDimensions.isVisible && edition.alternateDimensions && edition.alternateDimensions.length > 0;
        const showFraming = extended.includes && extended.includes.framing && extended.includes.framing.isVisible && edition.framing && edition.framing.length > 0;
        const showInventoryNumber = extended.includes && extended.includes.number && extended.includes.number.isVisible && inventory.number && (inventory.number + '').length > 0;
        const showSku = extended.includes && extended.includes.sku && extended.includes.sku.isVisible && inventory.sku && inventory.sku.length > 0;

        const showFramed = edition.isFramed && extended.includes && extended.includes.framed && extended.includes.framed.isVisible;
        const showUnframed = !edition.isFramed && extended.includes && extended.includes.unframed && extended.includes.unframed.isVisible;

        const isFirstImageGif = images.length > 0 && images[0].extension === 'gif';

        return (
            <React.Fragment>
                <Container spaced={true}>
                    <Row style={style} className="cont__row--inventory-meta">
                        <div className="artwork__cont__outer">
                            <div className="artwork__cont">
                                {imageContent}
                            </div>
                            <div className="artwork__controls">
                                <Clickable onClick={this.handleShareModalOpen}><span className="i i-share" /> share</Clickable>
                                {
                                    extended.hasVirtualInstall && !isFirstImageGif &&
                                    <Clickable onClick={this.handleVirtualInstallOpen}><span className="i i-collector" /> virtual install</Clickable>
                                }
                            </div>
                        </div>
                        <div className="artwork__side" style={{ height: '100%' }}>
                            <div className="artwork__head">
                                {
                                    !this.state.isArtist &&
                                    inventory.artist &&
                                    <h2 className="artwork__artist notranslate">{inventory.artist.name} <span className="artwork__artist__lifespan">{inventory.artist.lifespan}</span></h2>
                                }
                                <div>
                                    <span className="artwork__title notranslate">{inventory.title}</span><Subtitle data={inventory} />
                                </div>
                            </div>
                            <div className="artwork__info buy">
                                <div className="artwork__info__item">
                                    <span className="artwork__info__value artwork__info__item__medium">{inventory.medium}</span>
                                </div>
                                <div className="artwork__info__item">
                                    <span className="artwork__info__value artwork__info__item__dimensions">
                                        <React.Fragment>
                                            {edition.dimensions && edition.dimensions.display && edition.dimensions.display.formatted}
                                            {
                                                showAlternateDimensions &&
                                                <span className="artwork__info__value--altdim artwork__info__item__altdims"> ({extended.includes.alternateDimensions.prefix}{edition.alternateDimensions})</span>
                                            }
                                        </React.Fragment>
                                    </span>
                                </div>
                                {
                                    showFraming &&
                                    <div className="artwork__info__item">
                                        <span className="artwork__info__value artwork__info__item__framing__dimensions">
                                            <React.Fragment>
                                                {extended.includes.framing.prefix}{edition.framing}
                                            </React.Fragment>
                                        </span>
                                    </div>
                                }
                                {
                                    (showInventoryNumber || showSku) &&
                                    <div className="artwork__info__item artwork__info__item__sku">
                                        <span className="artwork__info__value">
                                            {
                                                showInventoryNumber &&
                                                <React.Fragment>
                                                    {extended.includes.number.prefix}{inventory.number}
                                                </React.Fragment>
                                            }
                                            {
                                                showSku &&
                                                <React.Fragment>
                                                    {
                                                        showInventoryNumber &&
                                                        <React.Fragment> / </React.Fragment>
                                                    }
                                                    {extended.includes.sku.prefix}{inventory.sku}
                                                </React.Fragment>
                                            }
                                        </span>
                                    </div>
                                }
                                {
                                    blockConfig.showPrice &&
                                    <div className="artwork__info__item">
                                        <span className="artwork__info__value artwork__info__item__price">{edition.price}</span>
                                    </div>
                                }
                                {
                                    showFramed &&
                                    <div className="artwork__info__item">
                                        <span className="artwork__info__value artwork__info__item__framed">
                                            {extended.includes.framed.prefix}
                                        </span>
                                    </div>
                                }
                                {
                                    showUnframed &&
                                    <div className="artwork__info__item">
                                        <span className="artwork__info__value artwork__info__item__unframed">
                                            {extended.includes.unframed.prefix}
                                        </span>
                                    </div>
                                }
                            </div>
                            {
                                inventory.available &&
                                blockConfig.showPrice &&
                                <React.Fragment>
                                    {
                                        this.props.config.isStripeConnected &&
                                        <Clickable id="detail-purchase-btn" className="btn btn--fill btn--sm m-b-sm form__btn btn--purchase" onClick={this.handlePurchaseModalOpen}>Purchase</Clickable>
                                    }
                                    {
                                        this.props.config.canReceiveOffers &&
                                        <Clickable id="detail-offer-btn" className="btn btn--outl btn--prim btn--md form__btn btn--offer" onClick={this.handleOfferModalOpen}>Make an Offer</Clickable>
                                    }
                                </React.Fragment>
                            }
                            <Clickable id="inquire-btn" className="btn btn--outl btn--prim btn--md form__btn btn--inquire" onClick={this.handleInquireModalOpen}>Inquire</Clickable>
                            {
                                inventory.notes &&
                                inventory.notes.length > 0 &&
                                <div className="artwork__info">
                                    <div className="artwork__notes" dangerouslySetInnerHTML={{ __html: inventory.notes }} />
                                </div>
                            }
                        </div>
                    </Row>
                </Container>
                {
                    this.state.inquireModal &&
                    this.state.inquireModal.visible &&
                    <InquirePopup
                        builder={this.props.builder}
                        config={this.props.config}
                        inventory={inventory}
                        sub={this.props.config.subdomain}
                        onClose={this.handleInquireModalClose} />
                }
                {
                    this.state.offerModal &&
                    this.state.offerModal.visible &&
                    <OfferPopup
                        builder={this.props.builder}
                        config={this.props.config}
                        inventory={inventory}
                        localization={this.props.config.localization}
                        sub={this.props.config.subdomain}
                        onClose={this.handleOfferModalClose} />
                }
                {
                    this.state.purchaseModal &&
                    this.state.purchaseModal.visible &&
                    <PurchasePopup
                        builder={this.props.builder}
                        config={this.props.config}
                        inventory={inventory}
                        querySub={this.props.querySub}
                        sub={this.props.config.subdomain}
                        onClose={this.handlePurchaseModalClose} />
                }
                {
                    this.state.shareModal &&
                    this.state.shareModal.visible &&
                    <ShareModal
                        builder={this.props.builder}
                        inventory={inventory}
                        pageConfig={data}
                        sub={this.props.config.subdomain}
                        onClose={this.handleShareModalClose} />
                }
                {
                    this.state.virtualInstallModal &&
                    this.state.virtualInstallModal.visible &&
                    <VirtualInstallModal
                        data={{ Title: inventory.title, Dimensions: edition.dimensions }}
                        sub={this.props.config.subdomain}
                        image={_Image.url(images[0], undefined, 640)}
                        onClose={this.handleVirtualInstallClose} />
                }
                {
                    this.state.zoomModal &&
                    this.state.zoomModal.visible &&
                    <ZoomModal
                        blockIdentifier={this.props.blockIdentifier}
                        builder={this.props.builder}
                        config={this.props.config}
                        index={this.state.zoomModal.index}
                        inventory={inventory}
                        pageConfig={data}
                        onClose={this.handleZoomModalClose} />
                }
            </React.Fragment>
        );
    }
}
const InventoryMetaComponent = withConfig(_InventoryMetaComponent);

function _Slideshow(props) {
    const [dotsId, setDotsId] = React.useState(undefined);
    React.useEffect(() => {
        if (!props.blockIdentifier) {
            return;
        }
        const id = `slider--dots-${props.blockIdentifier}`;
        setDotsId(id);
    }, [props.blockIdentifier]);

    React.useEffect(() => {
        props.onRegisterConfigHandler((config) => config.dotsContainer = `#${dotsId}`)
    }, [dotsId])

    const handleClick = function (event) {
        let index = props.page ? props.page.index : 0;
        if (!event || !event.target || !event.target.className || !event.target.className.indexOf) {
            props.onClick(index);
        } else if (event.target.className.indexOf('owl-next') < 0 && event.target.className.indexOf('owl-prev') < 0) {
            props.onClick(index);
        }
    }

    const images = props.data.images || [];
    const sliderDots = [];
    const slides = images.map(function (d, i) {
        sliderDots.push(<SlideshowDot key={`${i}_${d.id}-dot`} image={d} />);
        return (
            <Slide key={`${i}_${d.id}`} index={i} {...props} data={d} />
        );
    });
    let sliderId;
    if (dotsId) {
        sliderId = props.sliderId;
    }
    let renderDots = true;
    if (props.blockConfig && props.blockConfig.block) {
        renderDots = props.blockConfig.block.includeThumbnails == true;
    }
    const imageStyle = {};
    Utilities.copyObject(props.imageStyle, imageStyle);
    Utilities.copyObject(props.style, imageStyle);
    return (
        <React.Fragment>
            <div className="artwork__img" onClick={handleClick} style={imageStyle}>
                <div id={sliderId} className="slider slider--full__width">
                    {slides}
                </div>
            </div>
            {
                renderDots &&
                <div id={dotsId} className="slider__dots--full__width" style={props.style}>
                    {sliderDots}
                </div>
            }
        </React.Fragment>
    );
}
const Slideshow = withSlideshowInitialization(
    _Slideshow,
    {
        dots: true,
        items: 1,
        loop: true,
        nav: true,
        navText: false,
        responsiveClass: true,
        smartSpeed: 1000
    }
);

function Slide(props) {
    const seo = props.data.seo || {};
    let imageUrl;
    if (props.imageSize) {
        imageUrl = _Image.url(props.data, undefined, props.imageSize);
    }
    let imageStyle;
    if (!props.builder && !props.config.canDownloadImages) {
        imageStyle = { pointerEvents: 'none' };
    }
    return (
        <div className={props.legacy ? "slider__slide" : "slide__cont"}>
            {
                imageUrl &&
                <img
                    alt={seo.imageAlt}
                    caption={seo.imageCaption}
                    description={seo.imageDescription}
                    id={`imageSlide-${props.index}`}
                    src={imageUrl}
                    style={imageStyle}
                    title={seo.imageTitle} />
            }
        </div>
    );
}

const Legacy = { Component: InventoryMetaComponent };

// #endregion LEGACY

// #region IMAGE

function InventoryImageComponent(props) {
    const [blockIdentifier, setBlockIdentifier] = React.useState(undefined);
    React.useEffect(() => {
        setBlockIdentifier(Utilities.generateUniqueId());
    }, []);

    const [zoomModal, setZoomModal] = React.useState(undefined);
    const handleImageClick = (index) => {
        if (props.builder) {
            return;
        }
        setZoomModal({ index: index, visible: true });
    }
    const blockConfig = props.blockConfig || {};
    if (!blockConfig.block) {
        blockConfig.block = {};
    }
    if (!blockConfig.block.itemSpacing) {
        blockConfig.block.itemSpacing = { 'unit': 'px', 'value': '0' };
    }
    let className = 'inventory__image--slider';
    if (blockConfig && blockConfig.layout &&
        (blockConfig.layout.height && blockConfig.layout.height.value && blockConfig.layout.height.value.length > 0) ||
        (blockConfig.layout.maxHeight && blockConfig.layout.maxHeight.value && blockConfig.layout.maxHeight.value.length > 0) ||
        (blockConfig.layout.minHeight && blockConfig.layout.minHeight.value && blockConfig.layout.minHeight.value.length > 0)) {
        className += ' inventory__image--slider__custom__height';
    }
    let showAllImages = true;
    let SlidePreviewComponent;
    if (blockConfig.block.includeThumbnails == true) {
        SlidePreviewComponent = InventoryImageSlidePreview;
    } else if (!blockConfig.block.arrowsVisible) {
        showAllImages = false;
    }
    const handleStyleAdjustment = (style, arrowProps) => {
        const _arrowProps = arrowProps || {};
        let value = 40;
        if (_arrowProps.style && _arrowProps.style.fontSize) {
            let temp = parseFloat(_arrowProps.style.fontSize);
            if (!isNaN(temp)) {
                value = temp;
            }
        }
        let temp = parseFloat(style.paddingLeft);
        if (!isNaN(temp)) {
            value += temp;
        }
        style.paddingLeft = value;

        value = 40;
        temp = parseFloat(style.paddingRight);
        if (!isNaN(temp)) {
            value += temp;
        }
        style.paddingRight = value;
    }
    const data = props.data || {};
    const inventory = data.inventory || {};
    let content = (
        <React.Fragment>
            <Carousel.Component
                {...props}
                blockConfig={blockConfig}
                className={className}
                data={inventory.images}
                seo={inventory.seo}
                slideComponent={InventoryImageSlide}
                slidePreviewComponent={SlidePreviewComponent}
                onClick={handleImageClick}
                onStyleAdjustment={handleStyleAdjustment} />
            {
                zoomModal &&
                zoomModal.visible &&
                <ZoomModal
                    blockIdentifier={blockIdentifier}
                    builder={props.builder}
                    config={props.config}
                    index={zoomModal.index}
                    inventory={inventory}
                    pageConfig={data}
                    showAllImages={showAllImages}
                    onClose={() => setZoomModal(undefined)} />
            }
        </React.Fragment>
    );
    return content;
}

function InventoryImageSlide(props) {
    const seo = props.seo || {};
    let imageUrl;
    if (props.imageSize) {
        imageUrl = _Image.url(props.data, undefined, props.imageSize);
    }
    let imageStyle;
    if (!props.builder && !props.config.canDownloadImages) {
        imageStyle = { pointerEvents: 'none' };
    }
    return (
        <div className="slide__cont" onClick={() => props.onClick(props.index, props.data)}>
            {
                imageUrl &&
                <img
                    alt={seo.imageAlt}
                    caption={seo.imageCaption}
                    description={seo.imageDescription}
                    src={imageUrl}
                    style={imageStyle}
                    title={seo.imageTitle} />
            }
        </div>
    );
}

function InventoryImageSlidePreview(props) {
    return <span className="slide__preview" style={{ backgroundImage: `url(${_Image.url(props.data, undefined, 320)})` }} onClick={props.onClick} />
}
const Image = { Component: InventoryImageComponent };

// #endregion IMAGE

// #region TOKENIZED

function _InventoryMetaTokenized(props) {
    let style = {};
    if (props.blockConfig && props.blockConfig.block) {
        Block.mapStyleConfigProps(style, props.blockConfig.block, (propName) => { return propName == 'design'; });
    }
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit(style, props, { alignment: 'textAlign' });
    let className = 'cont--inventory__meta';
    if (!props.inLayout) {
        className += ' cont--kit__content';
    }
    let renderedContent = (
        <div className={className} style={layoutStyles.style}>
            {
                props.content != undefined &&
                <div className="cont--token" dangerouslySetInnerHTML={{ __html: props.content }} style={{ lineHeight: 1 }} />
            }
            {
                props.builder &&
                (props.content == undefined || props.content.length == 0) &&
                <EmptyPlaceholder />
            }
        </div>
    );
    if (layoutStyles.containerStyle) {
        renderedContent = <div className="cont--kit__wrapper" style={layoutStyles.containerStyle}>{renderedContent}</div>
    }
    return renderedContent;
}
const InventoryMetaTokenized = Token.withContentTokenParsing(_InventoryMetaTokenized, { headerConversionMap: { [Token.Title]: 'h1', [Token.ArtistName]: 'h2' } }, (props, keyword, options) => {
    const data = props.data || {};
    const inventory = data.inventory || {};
    const edition = InventoryHelper.edition(inventory) || {};
    const isArtist = props.config && props.config.userType == 1;
    return Token.parsing.inventory({ edition, inventory, isArtist }, keyword, options)
});
const InventoryMetaTokens = () => {
    const tokens = [
        Token.getWrappedTokenConfig('Artist Name', Token.ArtistName),
        Token.getWrappedTokenConfig('Artist Lifespan', Token.ArtistLifespan),
        Token.getWrappedTokenConfig('Title', Token.Title),
        Token.getWrappedTokenConfig('Edition Info', Token.Edition),
        Token.getWrappedTokenConfig('Created Date', Token.Date),
        Token.getWrappedTokenConfig('Medium', Token.Medium),
        Token.getWrappedTokenConfig('Dimensions', Token.Dimensions),
        Token.getWrappedTokenConfig('Alternate Dimensions', Token.AlternateDimensions),
        Token.getWrappedTokenConfig('Framing Dimensions', Token.Framing),
        Token.getWrappedTokenConfig('Inventory Number', Token.InventoryNumber),
        Token.getWrappedTokenConfig('SKU', Token.SKU),
        Token.getWrappedTokenConfig('Quantity', Token.Quantity),
        Token.getPriceTokenConfig(),
        Token.getAlternatePricesTokenConfig(),
        {
            display: 'Framed',
            options: [{ display: 'Display Text', name: 'display' }],
            token: Token.Framed
        },
        {
            display: 'Unframed',
            options: [{ display: 'Display Text', name: 'display' }],
            token: Token.Unframed
        },
        Token.getWrappedTokenConfig('Mounting', Token.Mounting),
        Token.getWrappedTokenConfig('Location', Token.Location),
        {
            display: 'Sold',
            options: [{ display: 'Display Text', name: 'display' }],
            token: Token.Sold
        },
        Token.getStatusIndicatorTokenConfig(Token.StatusIndicator),
        Token.getWrappedTokenConfig('Notes', Token.Notes)
    ];
    return tokens;
}
const Tokenized = { Component: InventoryMetaTokenized, Tokens: InventoryMetaTokens };

// #endregion TOKENIZED

export { Image, Legacy, Tokenized };